/**
 * Extrae un mensaje de error legible de una respuesta de error de API
 * Maneja tanto strings como arrays de errores de validación de Pydantic
 */
export const getErrorMessage = (error, defaultMsg = 'Ha ocurrido un error') => {
  const errorDetail = error?.response?.data?.detail;
  
  // Si es un string, retornarlo directamente
  if (typeof errorDetail === 'string') {
    return errorDetail;
  }
  
  // Si es un array de errores de validación de Pydantic
  if (Array.isArray(errorDetail) && errorDetail.length > 0) {
    const first = errorDetail[0];
    if (typeof first === 'string') return first;
    if (typeof first === 'object' && first !== null) {
      // Pydantic v2 error object: {type, loc, msg, input, url}
      return first.msg || defaultMsg;
    }
    return defaultMsg;
  }
  
  // Si es un objeto (ej: Pydantic error object directamente)
  if (typeof errorDetail === 'object' && errorDetail !== null) {
    if (errorDetail.msg) return errorDetail.msg;
    // Intentar serializar a string legible
    try {
      return JSON.stringify(errorDetail);
    } catch {
      return defaultMsg;
    }
  }
  
  // Fallback al mensaje por defecto
  return defaultMsg;
};
